var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 1350,
    height: 1140,
    viewBox: "0 0 1350 1140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1064.4 1137.6H1347.8",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.3 1127.4H731.3",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 1038.3V912.6H260.2V1038.3L127 1073V1091.5L284.4 1073L441.7 1091.5V1073L308.5 1038.3Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.6 1003L464.4 1046.4C464.4 1046.4 469.9 1069.8 490.8 1069.6C511.7 1069.4 508.4 1061.9 508.4 1061.9L529.7 1009.1L477.6 1003Z",
    fill: "#FFDFD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M466.6 1039.5C466.6 1039.5 463.1 1039.6 460.3 1046.7C457.5 1053.8 446.4 1079.2 446.4 1079.2L511.6 1119.4L579.7 1125.6C579.7 1125.6 591.3 1119.5 583.1 1106.9C574.9 1094.4 533.9 1081.5 533.9 1081.5L512.4 1055.1C512.4 1055.1 499 1057.7 484.8 1052.7C470.5 1047.8 466.6 1039.5 466.6 1039.5Z",
    fill: "#1A051D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.1 939.3H1193.1L1199.3 719.5H1212.9L1219.1 939.3Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M695.3 1073.8H674.6H653.9L546.5 1104V1114.2H674.6H802.7V1104L695.3 1073.8Z",
    fill: "#BDBDBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.1 458.4C317.1 458.4 332.6 409.1 332.8 408.2C333.1 407.3 315.5 365.1 326.4 342C337.2 318.8 361.6 321.2 371.2 321.5C380.9 321.8 413.4 329.7 411.9 350.2C410.4 370.7 402.8 410.9 395.2 421.1C387.6 431.3 353.3 418.5 353.3 418.5L352.8 454L317.1 458.4Z",
    fill: "#FFDFD7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M505.9 1023.1L505.6 1063C505.6 1063 518.6 1083.8 527.6 1084C536.5 1084.1 555.1 1088.2 559.3 1064.9C563.4 1041.6 566.8 1024.6 566.8 1024.6L505.9 1023.1Z",
    fill: "#FFDFD7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.8 844C121.8 844 97.8 726.5 94.3 663.2C90.8 599.9 97.8 533.1 140 530.4C182.2 527.8 213 599 218.3 627.1C223.5 655.3 241.7 781.3 121.8 844Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144 862.8C144 862.8 126.4 862.4 127.3 879.1C128.2 895.8 135.2 912.5 195.9 916C256.6 919.5 389.8 910.7 415.7 903.3C441.6 895.8 457 880.4 432 854.5C406.9 828.6 277.7 844.4 247.4 847.5C216.9 850.5 144 862.8 144 862.8Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M435.6 1135.1C445.817 1135.1 454.1 1126.82 454.1 1116.6C454.1 1106.38 445.817 1098.1 435.6 1098.1C425.383 1098.1 417.1 1106.38 417.1 1116.6C417.1 1126.82 425.383 1135.1 435.6 1135.1Z",
    fill: "#BDBDBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.3 1135.1C147.517 1135.1 155.8 1126.82 155.8 1116.6C155.8 1106.38 147.517 1098.1 137.3 1098.1C127.083 1098.1 118.8 1106.38 118.8 1116.6C118.8 1126.82 127.083 1135.1 137.3 1135.1Z",
    fill: "#BDBDBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M709.1 698.4H640.1C636.2 698.4 633 695.2 633 691.3V665H716.1V691.3C716.1 695.2 713 698.4 709.1 698.4Z",
    fill: "#BDBDBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M695.2 698.4H653.9V1073.8H695.2V698.4Z",
    fill: "#BDBDBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M889.1 665H460.1V650L889.1 633.3V665Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M412.2 744.1C412.2 744.1 526.5 748.5 553.5 754.9C580.5 761.3 595.5 775.9 594.2 803.2C592.9 830.5 514.9 1012.2 514.9 1012.2L468.6 1005.8L489.7 863.4L412.2 744.1Z",
    fill: "#6D8BF0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M465.6 983.2L516.2 991.1L511.8 1016.7L461.6 1009L465.6 983.2Z",
    fill: "#6D8BF0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M505.6 1063C505.6 1063 498.4 1065.8 499 1073.8C499.6 1081.8 501.3 1116.9 501.3 1116.9C501.3 1116.9 500 1127.6 525 1127.5C550.1 1127.4 656.6 1126.3 656.6 1126.3C656.6 1126.3 664.8 1113.7 652.5 1104.3C640.2 1094.9 559.5 1063 559.5 1063C559.5 1063 550.5 1070.9 531.5 1071.1C512.5 1071.2 505.6 1063 505.6 1063Z",
    fill: "#1A051D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M332 410.9C332 410.9 315.4 388.6 317.1 359.3C318.8 330 320.2 310.4 334.6 305.7C349 301 354.8 309.8 354.8 309.8C354.8 309.8 367.7 300.1 382.3 301.3C397 302.5 399.9 321.3 399.9 321.3C399.9 321.3 409 313 419.8 316.2C430.6 319.4 423.1 340.2 411.9 339.4C411.9 339.4 391.6 337.3 368.2 341.5L362.3 368.2L353.8 366.7C353.8 366.7 357.3 352 349.1 350.3C340.9 348.5 333.6 358.2 338 369.9C342.4 381.6 340.6 400.6 332 410.9Z",
    fill: "#FE8163"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M643.476 643.209C640.814 643.313 638.6 641.184 638.6 638.52V638.52C638.6 636.038 640.534 633.984 643.012 633.836L801.141 624.39C803.845 624.229 806.186 626.251 806.42 628.95L806.648 631.578C806.894 634.421 804.714 636.893 801.862 637.005L643.476 643.209Z",
    fill: "#4F4F4F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M793 632.9L855.6 480L861.514 482.502C864.01 483.558 865.211 486.411 864.22 488.934L807.541 633.309C806.527 635.894 803.601 637.157 801.024 636.122L793 632.9Z",
    fill: "#4F4F4F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M808.07 192.67L798.099 182.7L763.31 217.49L773.28 227.46L808.07 192.67Z",
    fill: "#4A6AD6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.924 135.665L159.752 144.266L189.764 183.252L200.936 174.651L170.924 135.665Z",
    fill: "#FFC933"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.452 391.654L66.7239 385.587L45.5532 430L58.2813 436.067L79.452 391.654Z",
    fill: "#FFC933"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M951.924 195.984L937.833 195.455L935.989 244.621L950.079 245.15L951.924 195.984Z",
    fill: "#FFC933"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 261.4C20.6902 261.4 26.6 255.49 26.6 248.2C26.6 240.91 20.6902 235 13.4 235C6.10985 235 0.200012 240.91 0.200012 248.2C0.200012 255.49 6.10985 261.4 13.4 261.4Z",
    fill: "#4A6AD6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M777.3 85.2C782.989 85.2 787.6 80.5885 787.6 74.9C787.6 69.2115 782.989 64.6 777.3 64.6C771.611 64.6 767 69.2115 767 74.9C767 80.5885 771.611 85.2 777.3 85.2Z",
    fill: "#FFC933"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M639.2 42.9C647.319 42.9 653.9 36.3186 653.9 28.2C653.9 20.0814 647.319 13.5 639.2 13.5C631.081 13.5 624.5 20.0814 624.5 28.2C624.5 36.3186 631.081 42.9 639.2 42.9Z",
    fill: "#4A6AD6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1296 1136.2H1116.2L1085.2 933.1H1327L1296 1136.2Z",
    fill: "#BDBDBD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.1 734.1C1267.29 734.1 1316.9 684.493 1316.9 623.3C1316.9 562.107 1267.29 512.5 1206.1 512.5C1144.91 512.5 1095.3 562.107 1095.3 623.3C1095.3 684.493 1144.91 734.1 1206.1 734.1Z",
    fill: "#52CB96"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M235.1 31.2C242.059 31.2 247.7 25.5588 247.7 18.6C247.7 11.6412 242.059 6 235.1 6C228.141 6 222.5 11.6412 222.5 18.6C222.5 25.5588 228.141 31.2 235.1 31.2Z",
    fill: "#4A6AD6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M236.8 729.1C236.8 729.1 229.3 742.3 231.3 772.6C233.3 802.9 250.4 849.5 347.8 859.2C445.2 868.9 507.2 868 507.2 868V1029.3H571.4C571.4 1029.3 582 972.6 584.6 954.1C587.2 935.6 605.7 855.2 597.8 814.7C589.9 774.3 551.2 768.1 523.1 762.8C495 757.5 385.9 739.5 385.9 739.5L236.8 729.1Z",
    fill: "#4A6AD6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M505.8 1033.5L505.6 1063",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M578.2 1033.5H498.4V1003L583.3 1004.2L578.2 1033.5Z",
    fill: "#4A6AD6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M694.7 626.4C679.6 618.5 654.4 621.9 646 623.2C637.6 624.5 624.8 624.7 624.8 624.7L493.7 611.9L440.4 553.2C398.2 562.9 415.9 595.4 415.9 595.4L473.6 649.2L627.1 644C647.9 644.7 674.3 635.8 678.4 635.1C682.6 634.3 709.8 634.3 694.7 626.4Z",
    fill: "#FFDFD7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.1 727.4C230.1 727.4 271.4 739.3 299.6 737.1C327.7 734.9 385.8 739.7 385.8 739.7V566.9L421.8 613.4C421.8 613.4 441.1 572.1 460 557.1C460 557.1 388.8 475 362.4 458.8C336 442.5 314.5 454.8 309.2 469.4C304 483.8 230.1 727.4 230.1 727.4Z",
    fill: "#1A051D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.6400d4eed0b8d75a792c85d1345a8872.svg";
export { ForwardRef as ReactComponent };